/**
 * ShareAuthPage — 외부공유 추가 인증(전화 뒷4자리) 입력 화면 (F-04 §7)
 *
 * 외부 수신자용. 인증 불필요(공개 라우트) — 아직 공유 JWT가 없는 단계라 공통 페이지로 받는다.
 * ShareGate가 AUTH_TYPE=PHONE_LAST4 토큰에 대해 302 → /share-auth?token={token}.
 * 입력 → POST /v/{token}/verify → 성공 시 에이전트 콜백으로, 시도 초과 시 /share-error?reason=AUTH_FAILED.
 *
 * TODO: 입력 폼·verify 호출·시도 제한 UX는 추후. 현재는 골격(token 확인).
 */
import { useSearchParams } from 'react-router';

export function ShareAuthPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';

  return (
    <div className="flex h-full min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-lg font-bold text-text">본인 확인이 필요합니다</h1>
      <p className="mt-1 text-sm text-text-muted">전화번호 뒷 4자리를 입력해 주세요</p>
      <p className="text-xs text-text-muted">token: {token ? `${token.slice(0, 8)}…` : '(없음)'}</p>
    </div>
  );
}
